
export interface CrmInstallData {
	language?: string;

	selection: string;
	oldPath?: string;
	serialNumber?: string;
	userLogin?: string;
	userPassword?: string;
	userPassword2?: string;
	frontUrl?: string;
	
	mySqlUser?: string;
	mySqlPassword?: string;
	mySqlPath?: string;
	mySqlPort?: number;
	mySqlDatabaseName?: string;
	mySqlEncoding?: string;
	
	pathFulltext?: string;
	pathMail?: string;
	pathMount?: string;
	pathOther?: string;
	pathSpam?: string;
	forceCreate?: boolean;
	
	appCompany?: string;
	appStreet?: string;
	appCity?: string;
	appZip?: string;
	appCountry?: string;
	appIco?: string;
	appDic?: string;
	
	appMail?: string;
	appTel?: string;
	appWeb?: string;
	appAccount?: string;
	currency?: string;
	langID?: string;
	timeZoneID?: string;
}

export function useCrmInstallData() {

	function getData(url: string): Promise<Object> {
		//console.log("Get data from:"+url);
		return fetch(url)
		.then(response => response.json())
		.then(data => {
				return data;
		})
		.catch((error) => {
			console.log("Error from url:"+error.message);
			return null;
		});
	}

	function getInstallData(url: string): Promise<CrmInstallData> {
		//console.log("Get CrmInsallData from:"+url);
		return fetch(url)
		.then(response => response.json<CrmInstallData>())
		.then(data => {
				return data;
		})
		.catch((error) => {
			console.log("Error from url:"+error.message);
			return null;
		});
	}

	function getArrayData(url: string, defaultArray: Array<Object>): Promise<Array<Object>> {
		//console.log("Get data from:"+url);
		return fetch(url)
		.then(response => response.json())
		.then(data => {
				if (data.length>0) return data;
				else return defaultArray;
		})
		.catch((error) => {
			console.log("Error from url:"+error.message);
			return defaultArray;
		});
	}

	return  {
		 getData,getInstallData,getArrayData
		};

}
